module.exports = __webpack_public_path__ + "static/media/motherdough.9898251d.png";